import { defineComponent as r, createBlock as n, openBlock as o, unref as c, mergeProps as m, withCtx as p, createElementVNode as a } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconReassuranceTruckFilled",
  __name: "IconReassuranceTruckFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(e) {
    const t = e;
    return (i, l) => (o(), n(c(d), m(t, { "view-box": "0 0 48 48" }), {
      default: p(() => [...l[0] || (l[0] = [
        a("g", { "clip-path": "url(#c68m3la)" }, [
          a("path", { d: "M12.423 30.927a3.254 3.254 0 1 1 6.445.906 3.254 3.254 0 0 1-6.445-.906m17.66 2.482a3.254 3.254 0 1 1 6.445.906 3.254 3.254 0 0 1-6.445-.906" }),
          a("path", {
            "fill-rule": "evenodd",
            d: "M10.666 4.045a24 24 0 1 1 26.668 39.91 24 24 0 0 1-26.668-39.91m-.165 6.831A1.5 1.5 0 0 1 12.195 9.6l18.534 2.605a1.5 1.5 0 0 1 1.022.628l9.306 13.35a1.5 1.5 0 0 1 .255 1.068l-.788 5.606a1.5 1.5 0 0 1-1.694 1.277l-1.27-.178a4.255 4.255 0 0 0-8.37-1.177l-9.29-1.305a4.255 4.255 0 0 0-8.37-1.177l-2.2-.309a1.5 1.5 0 0 1-1.277-1.694l.637-4.526a.5.5 0 1 0-.99-.139l-.637 4.526a2.5 2.5 0 0 0 2.128 2.823l2.2.31a4.255 4.255 0 0 0 8.369 1.176l9.292 1.306a4.255 4.255 0 0 0 8.368 1.176l1.271.178a2.5 2.5 0 0 0 2.824-2.127l.788-5.607a2.5 2.5 0 0 0-.425-1.778L32.57 12.26a2.5 2.5 0 0 0-1.703-1.046L12.335 8.609a2.5 2.5 0 0 0-2.824 2.128l-.244 1.737a.5.5 0 1 0 .99.14l.244-1.738m-3.616 5.055a.5.5 0 0 1 .565-.426l3.718.523a.5.5 0 1 1-.14.99l-3.717-.522a.5.5 0 0 1-.426-.565m-.522 3.718a.5.5 0 0 1 .565-.426l7.435 1.045a.5.5 0 1 1-.139.99l-7.436-1.044a.5.5 0 0 1-.425-.565M28.67 19.12c-.119.906-.588 1.598-1.021 1.538-.433-.06-.7-.85-.57-1.756.128-.907.588-1.598 1.021-1.528.434.07.7.84.57 1.746m3.153 1.99c-.439.019-.804-.745-.805-1.656-.002-.911.355-1.658.805-1.668.45-.01.804.744.806 1.665.002.92-.325 1.656-.805 1.658m-8.836-.6a.34.34 0 0 1 .464.068 13.827 13.827 0 0 0 1.669 1.927 9.444 9.444 0 0 0 1.997 1.43A9.55 9.55 0 0 0 32 24.974a.331.331 0 1 1 .08.657 8.529 8.529 0 0 1-2.757.125 8.372 8.372 0 0 1-3.875-1.556 7.788 7.788 0 0 1-1.044-.953 7.101 7.101 0 0 1-1.5-2.385.35.35 0 0 1 .114-.355l-.03.001",
            "clip-rule": "evenodd"
          })
        ], -1),
        a("defs", null, [
          a("clipPath", { id: "c68m3la" }, [
            a("path", { d: "M0 0h48v48H0z" })
          ])
        ], -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
